import InformationModal from '../../../shared/components/modal-information';

export default class MentorUnavailabilityModal extends InformationModal {
  markModalAsRead() {
    $.ajax({
      url: this.$element.find('.unavailabilityModal-nav')[0].dataset.readUrl,
      type: 'PUT',
      dataType: 'json',
    });
  }
}
